import { madridDay } from "./dailyBrief";

const KEY = "gula-brief-sent";
export const BRIEF_SENT_EVENT = "gula-brief-sent";
/** From this hour (Madrid) the reminder shows up */
export const BRIEF_HOUR = 9;

/** Remembers on this device that today's parte went out (or was dismissed). */
export const markBriefSent = (now = new Date()) => {
  try {
    localStorage.setItem(KEY, madridDay(now));
  } catch {
    // private window: the reminder comes back on reload
  }
  window.dispatchEvent(new Event(BRIEF_SENT_EVENT));
};

export const briefSentToday = (now = new Date()) => {
  try {
    return localStorage.getItem(KEY) === madridDay(now);
  } catch {
    return false;
  }
};

/** Hour of the day in Madrid (0-23). */
export const madridHour = (now = new Date()) =>
  Number(
    now.toLocaleString("en-GB", {
      timeZone: "Europe/Madrid",
      hour: "2-digit",
      hour12: false,
    }),
  );

/** 9:00–21:00, Monday to Saturday (Sunday no calls). */
export const briefDue = (now = new Date()) => {
  const hour = madridHour(now);
  const weekday = new Date(`${madridDay(now)}T12:00:00Z`).getUTCDay();
  return weekday !== 0 && hour >= BRIEF_HOUR && hour < 21;
};
